import React from 'react';

const AmoebaLink = ({children, href, style, className}) => (
  <a
    href={`${process.env.REACT_APP_AMOEBA_URL}${href}`}
    style={style}
    className={className}
  >
    {children}
  </a>
);

export default AmoebaLink;
